import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const IcoWidgetAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "ico-widget" */ './ico-widget'),
  componentName: 'IcoWidget',
});
